module.exports = __webpack_public_path__ + "8ddf7da79b693f76f75cb94ef62fc4aa.png";